export default "__VITE_ASSET__Pax1r2Mq__"